import { SearchToneRequestImpl } from 'src/com/sixdee/crbtportal/core/api/search/searchtone/searchtonerequest';
import { SearchToneBasedOnCodeResponse } from 'src/com/sixdee/crbtportal/core/api/search/searchtonebasedoncode/searchtonebasedoncoderesponse';
import { APIModel, APIModelImpl, APIModelHandler } from '../../toolkit/uicomponentapimodel';
import { ToneDto } from '../../../core/dto/tonedto';
import { BuyToneDto } from '../../../core/dto/buytone/buytonedto';
import { BaseContext } from '../../../utils/basecontext';
import { GetTonePriceDtoImpl } from '../../../core/dto/gettoneprice/gettonepricedto';
import { GetTonePriceResponse } from '../../../core/api/tune/gettuneprice/gettonepriceresponse';
import { GetTonePriceRequestImpl } from '../../../core/api/tune/gettuneprice/gettonepricerequest';
import { BuyToneResponse } from '../../../core/api/tune/buytune/buytoneresponse';
import { BuyToneRequestImpl } from '../../../core/api/tune/buytune/buytonerequest';
import { SearchToneDtoImpl } from '../../../core/dto/searchtone/searchtonedto';
import { SettingsResponse } from '../../../core/api/settings/settingsresponse';
import { SettingsRequestImpl } from '../../../core/api/settings/settingsrequest';
import { LoginDtoImpl } from '../../../core/dto/login/logindto';
import { LoginResponse } from '../../../core/api/login/loginresponse';
import { LoginRequestImpl } from '../../../core/api/login/loginrequest';
import { SendOTPDto } from '../../../core/dto/otp/sendotp/sendotpdto';
import { GenerateOTPDtoImpl } from '../../../core/dto/otp/generateotp/generateotpdto';
import { GenerateOTPResponse } from '../../../core/api/otp/generateotp/generateotpresponse';
import { GenerateOTPRequestImpl } from '../../../core/api/otp/generateotp/generateotprequest';
// import { SearchToneBasedOnCodeResponse } from 'src/com/sixdee/crbtportal/core/api/search/searchtonebasedoncode/searchtonebasedoncoderesponse';

export interface LandingPageAPIModel extends APIModel
{
    getSettings(): void;
    getSearchToneBasedOnId(searchKey: string): void;
    getTonePrice(toneDto: ToneDto): void;
    buyTone(buyToneDto: BuyToneDto): void;
    login(): void;
    getOTP(createAccountOtpDto: SendOTPDto): void ;
}

export class LandingPageAPIModelImpl extends APIModelImpl implements LandingPageAPIModel
{
    constructor(applicationContext: BaseContext, apiModelHandler: APIModelHandler)
    {
        super(applicationContext, apiModelHandler);
    }

    getOTP(createAccountOtpDto: SendOTPDto): void 
    {
      let generateOtp = new GenerateOTPDtoImpl();
      generateOtp.setMsisdn(createAccountOtpDto.getMsisdn());

        this.getContext().getAPIProcessorFactory().getLoginAPIProcessorFactory().generateOTP()
                .success((generateOTPResponse : GenerateOTPResponse)=>
                {
                    this.getAPIModelHandler().onSuccess(generateOTPResponse.getAPIFeature(), 
                    generateOTPResponse.getDescription(), generateOTPResponse);
                })
                .failure((generateOTPResponse : GenerateOTPResponse)=>
                {
                    this.getAPIModelHandler().onFailure(generateOTPResponse.getAPIFeature(), 
                         generateOTPResponse.getDescription(), generateOTPResponse);

                }).execute(new GenerateOTPRequestImpl(generateOtp));
    }

    getSettings(): void 
    {    
     this.getContext().getAPIProcessorFactory().getLoginAPIProcessorFactory().getSettings()
         .success((settingsResponse: SettingsResponse) => {
           this.getAPIModelHandler().onSuccess(settingsResponse.getAPIFeature(), 
           settingsResponse.getDescription(), settingsResponse); 
         })
         .failure((settingsResponse: SettingsResponse) => {
           this.getAPIModelHandler().onFailure(settingsResponse.getAPIFeature(), 
           settingsResponse.getDescription(), settingsResponse);
         })
         .execute(new SettingsRequestImpl());
       }

       login(): void 
       {
         let loginDto = new LoginDtoImpl();
         loginDto.setMsisdn(this.getContext().getUserContext().getMsisdn());

        this.getContext().getAPIProcessorFactory().getLoginAPIProcessorFactory().login()
         .success((settingsResponse: LoginResponse) => {
           this.getAPIModelHandler().onSuccess(settingsResponse.getAPIFeature(), 
           settingsResponse.getDescription(), settingsResponse); 
         })
         .failure((settingsResponse: LoginResponse) => {
           this.getAPIModelHandler().onFailure(settingsResponse.getAPIFeature(), 
           settingsResponse.getDescription(), settingsResponse);
         })
         .execute(new LoginRequestImpl(loginDto, ""));
      }
 
    getTonePrice(toneDto: ToneDto): void 
    {
        let getTonePriceDto =  new GetTonePriceDtoImpl();
        getTonePriceDto.setLanguage(this.getContext().getUserContext().getLanguage());
        getTonePriceDto.setServiceId("1");
        getTonePriceDto.setAPartyMsisdn(this.getContext().getUserContext().getMsisdn());
        getTonePriceDto.setToneId(toneDto.getId());
        getTonePriceDto.setValidationIdentifier("3");
        getTonePriceDto.setChannelId(this.getContext().getUserContext().getChannelId());

        this.getAPIProcesssorFactory().getToneProcessorFactory().getGetTonePriceAPIProcessorNonLoggedInUser()
        .success((getTonePriceResponse : GetTonePriceResponse)=>
         {
            this.getAPIModelHandler().onSuccess(getTonePriceResponse.getAPIFeature(), 
            getTonePriceResponse.getDescription(), getTonePriceResponse.getGetTonePriceDto().getToneDetailsList()[0]);
         })
       .failure((getTonePriceResponse : GetTonePriceResponse)=>
       {
           this.getAPIModelHandler().onFailure(getTonePriceResponse.getAPIFeature(), 
           getTonePriceResponse.getDescription(), getTonePriceResponse);
         })
       .execute(new GetTonePriceRequestImpl(getTonePriceDto));
    }
    
    buyTone(buyToneDto: BuyToneDto): void 
    {
        this.getAPIProcesssorFactory().getToneProcessorFactory().getBuyToneNonLoggedUserAPIProcessor()
        .success((buyResponse : BuyToneResponse)=>
         {
            this.getAPIModelHandler().onSuccess(buyResponse.getAPIFeature(), 
            buyResponse.getDescription(), buyResponse);
         })
       .failure((buyResponse : BuyToneResponse)=>
       {
           this.getAPIModelHandler().onFailure(buyResponse.getAPIFeature(), 
           buyResponse.getDescription(), buyResponse);
         })
       .execute(new BuyToneRequestImpl(buyToneDto));
    }

    getSearchToneBasedOnId(searchKey: string): void
    {
        let searchToneDto = new SearchToneDtoImpl();
        searchToneDto.setPagePerCount(0);
        searchToneDto.setLanguage(this.getContext().getUserContext().getLanguage());
        searchToneDto.setToneId(searchKey); 
        searchToneDto.setCategoryId(0);
        searchToneDto.setPageNo(0);

        this.getAPIProcesssorFactory().getSearchToneProcessorFactory()
        .getToneBasedOnCode()
        .success((searchToneResponse: SearchToneBasedOnCodeResponse)=>
        {
          if(searchToneResponse.getSearchToneDto().length > 0)
          {
            this.getAPIModelHandler().onSuccess(searchToneResponse.getAPIFeature(), 
            searchToneResponse.getDescription(), searchToneResponse.getSearchToneDto());

          }
          else
          {
            this.getAPIModelHandler().onFailure(searchToneResponse.getAPIFeature(), 
            searchToneResponse.getDescription(), undefined);
          }
         })
        .failure((searchToneResponse : SearchToneBasedOnCodeResponse)=>
         {
           this.getAPIModelHandler().onFailure(searchToneResponse.getAPIFeature(), 
           searchToneResponse.getDescription(), undefined);
         })
        .execute(new SearchToneRequestImpl(searchToneDto));
    }

    // getTone()
    // {
    //   let tone3 = new ToneDtoImpl();
    //   tone3.setId("915284");
    //   tone3.setToneName("1234rsva");
    //   tone3.setArtistName("987ytrfgbnmk9 87659876545678");
    //   tone3.setImgPath("http://placehold.it/120x120&text=image3");
    //   tone3.setToneUrl("https://callertunes.etisalat.ae/servlet/MobileStreamMediaServlet?fileId=JP0pty9iYIO9U+4tDVjc3o97SAWzJj1fTO9eb7I7ccCSvtxOpEhxZYt/AgeU5Q39fh+QY4LKw5LfRp5KT5lW1Q==");

    //   return [tone3];
    // }
}


 


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/landingpage/landingpageapimodel.ts